// DOM-free helpers for the device-join rolling-code view. Kept pure so they are
// unit-testable in Node without a DOM (no timers, no document).

/** Group a 6-digit code as "482 915" for readable display. */
export function formatCode(code: string): string {
  const c = (code || '').replace(/\s+/g, '');
  if (c.length !== 6) return c;
  return `${c.slice(0, 3)} ${c.slice(3)}`;
}

/**
 * Fraction (0..1) of the current window REMAINING, given seconds_remaining and
 * the period. Used to draw a countdown ring (1 = full, 0 = expired). Clamped.
 */
export function countdownFraction(secondsRemaining: number, period = 30): number {
  if (period <= 0) return 0;
  const f = secondsRemaining / period;
  if (f < 0) return 0;
  if (f > 1) return 1;
  return f;
}
